import axios from "axios";
import toast from "react-hot-toast";
import i18n from "../i18n";

console.log("API URL:", import.meta.env.VITE_API_URL);

const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

// Add a request interceptor to include JWT token
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("JWT_TOKEN");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log("JWT Token add to header");
    }
    return config;
  },
  (error) => {

    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // success
    return response;
  },
  (error) => {

    // Error from backend
    const errorData = error.response?.data;
    const status = error.response?.status;
    const code = errorData?.code;

    const message = i18n.t(`${code}`, {
      defaultValue: errorData?.message || "Unknown error"
    });

    // Error handling
    switch (status) {
      case 400:
        // Bad Request - validation error
        toast.error(message || "Invalid request");
        console.log(errorData?.message || "Invalid request");
        break;

      case 401:
        // Unauthorized - logout
        toast.error("Session expired, please login again");
        console.log("Session expired, please login again");
        localStorage.removeItem("JWT_TOKEN");
        window.location.href = "/login";
        break;

      case 403:
        // Forbidden - no permission
        toast.error("You don't have permission to do this");
        console.log("You don't have permission to do this");
        break;

      case 404:
        // Not Found
        toast.error(message || "Resource not found");
        console.log(errorData?.message || "Resource not found");
        break;

      case 500:
        // Internal Server Error
        toast.error("Server error, please try again later");
        console.log("Server error, please try again later");
        break;

      default:
        // Other Errors
        toast.error(message || "Something went wrong");
        console.log(errorData?.message || "Something went wrong");
    }

    // Return error for compotent processing
    return Promise.reject(error);
  }
);

export default api;

// import axios from "axios";

// console.log("API URL:", import.meta.env.VITE_API_URL);

// // Create an Axios instance
// const api = axios.create({
//   baseURL: `${import.meta.env.VITE_API_URL}/api`,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//   },
//   withCredentials: true,
// });

// // Add a request interceptor to include JWT and CSRF tokens
// api.interceptors.request.use(
//   async (config) => {
//     const token = localStorage.getItem("JWT_TOKEN");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     let csrfToken = localStorage.getItem("CSRF_TOKEN");
//     if (!csrfToken) {
//       try {
//         const response = await axios.get(
//           `${import.meta.env.VITE_API_URL}/api/csrf-token`,
//           { withCredentials: true }
//         );
//         csrfToken = response.data.token;
//         localStorage.setItem("CSRF_TOKEN", csrfToken);
//       } catch (error) {
//         console.error("Failed to fetch CSRF token", error);
//       }
//     }

//     if (csrfToken) {
//       config.headers["X-XSRF-TOKEN"] = csrfToken;
//     }
//     console.log("X-XSRF-TOKEN " + csrfToken);
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// export default api;
